import Head from 'next/head';
import { PageContext } from '@/context/PageContext';
import { useContext } from 'react';
import { getHrefLang } from './HrefLangHelpers';

export function HrefLang() {
  const { slug, page, survey, canonicalHostname } = useContext(PageContext);
  const availableLocales =
    page?.available_locales || survey?.languages?.map((language) => language.language_code) || [];
  const defaultLocale = page?.default_locale_code || survey?.default_language || 'en-US';
  const hrefLangs = getHrefLang(slug, defaultLocale, availableLocales, canonicalHostname);
  return (
    <Head>
      {hrefLangs.map((hrefLang) => (
        <link key={hrefLang.hrefLang} {...hrefLang} />
      ))}
    </Head>
  );
}
